import axios from 'axios'
import router from './router'

// 创建 axios 实例
const requests = axios.create({
	// baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
	baseURL: 'https://chat-admin.event1.cn/api/',
	timeout: 6000 // 请求超时时间
});

function refresh() {
	let token = localStorage.getItem('token')
	return new Promise((resolve, reject) => {
		let data = new FormData();
		data.append('token', token)
		requests.post("/token/refresh", data).then(res => {
			console.log(res)
			if (res.code) {
				resolve(res)
			}
		}).catch(e => {
			reject(e)
		})
	})
}

let seg = 0;
// 错误处理函数
const err = (error) => {
	if (error.response) {
		const data = error.response.data
		console.log(error.response.status);
		if (data.code == 401 && seg == 0) {
			seg++;
			localStorage.clear()
			return router.replace('/')
		}
	}
	return Promise.reject(error.response.status)
}

// request interceptor(请求拦截器)
requests.interceptors.request.use(config => {
	//   const token = Vue.ls.get(ACCESS_TOKEN)
	const token = localStorage.getItem('token')

	if (token) {
		config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
	}
	return config
}, err)

// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
	const res = response.data
	if (res.code === 401) {
		
		return Promise.reject('error');
	} else {
		return res;
	}
}, err);

export default requests



// WEBPACK FOOTER //
// ./src/newAxios.js